/* eslint-disable class-methods-use-this, import/no-extraneous-dependencies */
import useJwt from '@/auth/jwt/useJwt'

export default class ReportService {
  static getReports(filters) {
    return useJwt.post('/user/reports', {}, filters)
  }
}
